import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { api, describeError } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';
import { PasskeysCard } from '@/components/PasskeysCard';
import { MyOperatorAccessCard } from '@/components/MyOperatorAccessCard';

export function ProfilePage() {
  const operator = useAuthStore((s) => s.operator);
  const [searchParams, setSearchParams] = useSearchParams();
  const [codes, setCodes] = useState<string[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const wantsRegenerate = searchParams.get('regenerate') === '1';

  // O parametro da URL e o estado inicial do dialogo, nao um efeito que o abre
  // depois. Quem chega por `?regenerate=1` ja entra com ele aberto.
  const [confirmOpen, setConfirmOpen] = useState(wantsRegenerate);

  async function regenerate() {
    setError(null);
    setSubmitting(true);
    try {
      const { data } = await api.post<{ recoveryCodes: string[] }>(
        '/platform/auth/mfa/regenerate-codes',
        {},
      );
      setCodes(data.recoveryCodes);
      setConfirmOpen(false);
      // Drop the ?regenerate=1 query param now that the prompt resolved.
      if (wantsRegenerate) {
        searchParams.delete('regenerate');
        setSearchParams(searchParams, { replace: true });
      }
    } catch (err) {
      setError(describeError(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="page" style={{ maxWidth: 760 }}>
      <div className="card">
        <div className="card-title" style={{ marginBottom: 14 }}>Sua conta</div>
        <dl className="detail-grid" style={{ margin: 0 }}>
          <dt className="k" style={{ margin: 0 }}>Email</dt><dd style={{ margin: 0 }}>{operator?.email}</dd>
          <dt className="k" style={{ margin: 0 }}>Nome</dt><dd style={{ margin: 0 }}>{operator?.fullName}</dd>
          <dt className="k" style={{ margin: 0 }}>Papel</dt>
          <dd style={{ margin: 0 }}><span className="badge badge-primary">{operator?.role}</span></dd>
        </dl>
      </div>

      <div className="card">
        <h3 style={{ fontSize: 16 }}>Recovery codes</h3>
        <p className="muted" style={{ fontSize: 14 }}>
          Gerar novos códigos invalida os anteriores. Você verá os 10 novos códigos uma única vez.
        </p>

        {error && <div className="error-banner">{error}</div>}

        {codes ? (
          <>
            <div className="info-banner">
              Salve os códigos abaixo agora. Eles não serão mostrados novamente.
            </div>
            <ol className="mono" style={{ paddingLeft: 24 }}>
              {codes.map((c) => <li key={c} style={{ marginBottom: 4 }}>{c}</li>)}
            </ol>
            <button className="btn-ghost btn" onClick={() => setCodes(null)}>
              Ocultar
            </button>
          </>
        ) : confirmOpen ? (
          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button className="btn-danger btn" onClick={regenerate} disabled={submitting}>
              {submitting ? 'Gerando…' : 'Sim, gerar novos códigos'}
            </button>
            <button className="btn-secondary btn" onClick={() => setConfirmOpen(false)} disabled={submitting}>
              Cancelar
            </button>
          </div>
        ) : (
          <button className="btn-secondary btn" onClick={() => setConfirmOpen(true)}>
            Regenerar recovery codes
          </button>
        )}
      </div>

      <PasskeysCard mode="self" />

      <MyOperatorAccessCard />
    </div>
  );
}
